<template>
  <b-card class="border-0">
    <h4><b-icon icon="receipt"  class="mr-2"/><translate>Terms and conditions of payment</translate></h4>
    <ul>
      <li v-translate>The payments for the tourist services will be made only in Euro.</li>
      <li v-translate>All terms and conditions of payment will be shown on every hotel contract and on the invoices.</li>
      <li> <translate>The proof of payment will be sent to our Administration Department, at the e-mail address</translate>: <a href="mailto:office@marioviajes.com">office@marioviajes.com</a>.</li>
      <li v-translate>The travel documents will be active in our reservation system in maximum 48 working hours after we receive the
          full payment. Therefore, in order to have access to the travel documents, the terms of payment should be
          followed exactly as written on the invoice.</li>
      <li v-translate>If the payment deadlines are not met, the reservation will be cancelled and the tourists will not be able to
          proceed with the check in on site</li>
    </ul>
  </b-card>
</template>

<script>
export default {
  name: 'emailAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
